// extracted by mini-css-extract-plugin
export default {"root":"TimeZoneLabel_root__I8aRE"};